export default "__VITE_ASSET__B6yx1P3s__"